import { IApiError } from '@frontend/request';

import dealerAPI from '@aqx-core/common/api/dealer/api';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

import { ICompanyExposure, ICompanyExposureParams } from '../model';

export interface IDealerAPIController {
  getCompanyExposure: (
    callbacks: IAPIControllerCallbacks<ICompanyExposure[]>,
    params?: ICompanyExposureParams,
    signal?: AbortSignal
  ) => Promise<void>;
}

class DealerAPIController implements IDealerAPIController {
  public getCompanyExposure = async (
    callbacks: IAPIControllerCallbacks<ICompanyExposure[]>,
    params?: ICompanyExposureParams,
    signal?: AbortSignal
  ): Promise<void> => {
    try {
      const { result } = await dealerAPI.getCompanyExposure(params, signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const dealerAPIController = new DealerAPIController();
